export const TABLE_CELL_DATA = 'TABLE_CELL_DATA';

export const COLUMN_DEFAULT_MIN_WIDTH_PX = 40;
export const COLUMN_DEFAULT_SMALL_WIDTH_PX = 100;
export const COLUMN_DEFAULT_WIDTH_PX = 250;
export const COLUMN_DEFAULT_MAX_WIDTH_PX = 500;
